import React, { createContext } from "react";

type GlobalContextValue = {
    navIsOpen: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
    isDesktop: boolean;
};

export const GlobalContext = createContext<GlobalContextValue | undefined>(
    undefined
);

export function useGlobalContext() {
    const context = React.useContext(GlobalContext);
    if (!context) {
        throw new Error("useGlobalContext must be used within a GlobalContext");
    }
    return context;
}
